<ng-template #StornoAlert>
  <div class="modal-alert-storno">
    <div nxRow>
      <div nxCol="12" style="text-align: center;">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold"
          translate>
          policy.storno.modal.alert.title</h3>
        <br>
        <ng-template ngFor let-mtplPolicy="$implicit"
          [ngForOf]="policiesToCancel">
          <p nxCopytext="large" class="form-policies">
            {{ mtplPolicy.policyNumber }} - {{
              'claim.azk-lob.'+mtplPolicy.lobId | translate }} <span
              *ngIf="mtplPolicy.paymentBlockageFlag" class="blockage-flag"><b>
                {{
                'policy.storno.form.blockage' |
                translate }} </b></span>
          </p>
        </ng-template>
      </div>
    </div>
    <div nxRow>
      <div nxCol="12" style="text-align: center;">
        <form [formGroup]="confirmForm" (submit)="submitConfirmation($event)"
          class="form-buttons">
          <button nxButton="secondary normal" type="button"
            (click)="closeModal()"><span
              translate>policy.storno.modal.alert.cancel</span></button>
          <button nxButton="primary normal" type="submit"><span
              translate>policy.storno.modal.alert.submit</span></button>
        </form>
      </div>
    </div>
  </div>
</ng-template>
